import React from "react";
import "./Education.css";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

class Education extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            heading: props.heading,
            education: [],
        };
        this.getEducation = this.getEducation.bind(this);
    }

    componentDidMount() {
        this.getEducation();

        ScrollTrigger.config({ limitCallbacks: true });
        gsap.from(".education>.entry>*", {
            x: -100,
            autoAlpha: 0,
            ease: "back",
            duration: 1,
            stagger: 0.2,
            scrollTrigger: {
                trigger: ".education",
                start: "top 50%",
                once: true,
            },
        });
    }

    getEducation() {
        fetch("./data.json")
            .then((response) => response.json())
            .then((data) => {
                this.setState({ education: data.education });
                this.getEducation();
            })
            .catch((error) => console.log(error));
    }

    render() {
        const { heading, education } = this.state;
        return (
            <section className="education" id="education">
                <div className="entry">
                    <h1>{heading}</h1>
                </div>

                <div className="education-cards">
                    {education.map((education, index) => (
                        <div key={index} className="education-card">
                            <div className="company-details">
                                <div className="logo">
                                    <img src={education.logo} alt="" />
                                </div>
                                <div className="education-details">
                                    <div className="designation">{education.role}</div>
                                    <div className="period">
                                        <h3>
                                            {education.start} - {education.end}
                                        </h3>
                                    </div>
                                    <div className="company-name">
                                        <h3>{education.school}</h3>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </section>
        );
    }
}

export default Education;
